export const formSettings = {
    form: 'witness-onboarding-wizard',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
};



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/settings.jsx